import { create } from 'zustand';

interface CustomersSearchState {
  usersQuery: string;
  devicesQuery: string;
  setUsersQuery: (q: string) => void;
  setDevicesQuery: (q: string) => void;
}

/**
 * In-memory cache of the Customers page search terms (Users + Devices columns)
 * so they survive navigating away — e.g. to My devices and back via the
 * sidebar — and only reset when the user clears them or searches something
 * else. (URL params alone don't survive sidebar nav to a bare /staff/customers.)
 * Cleared on a full page reload.
 */
export const useCustomersSearchStore = create<CustomersSearchState>((set) => ({
  usersQuery: '',
  devicesQuery: '',
  setUsersQuery: (usersQuery) => set({ usersQuery }),
  setDevicesQuery: (devicesQuery) => set({ devicesQuery }),
}));
